export type Environment = 'local' | 'development' | 'release' | 'production';

export const getEnvironment = (): Environment => {
  const hostname = window.location.hostname;

  if (hostname.includes('localhost')) {
    return 'local';
  }

  if (hostname.includes('dev')) {
    return 'development';
  }

  if (hostname.includes('release')) {
    return 'release';
  }

  if (hostname === 'trackmanuniversity.com' || hostname === 'www.trackmanuniversity.com') {
    return 'production';
  }

  throw new Error(`Unknown environment for hostname: ${hostname}`);
};
